import { formatNodes } from "./format";
import { generateRandomAppName } from "./randomName";

export const eventStatusMap: Record<string, { label: string; color: string; hex: string; lightHex: string }> = {

  // for regular streams
  new: {
    label: "NEW",
    color: "info",
    hex: "#00a1f1",
    lightHex: "#e6f7ff",
  },
  starting: {
    label: "STARTING",
    color: "warning",
    hex: "#f1c40f",
    lightHex: "#fffbe6",
  },
  live: {
    label: "LIVE",
    color: "error",
    hex: "#e74c3c",
    lightHex: "#ffe6e6",
  },
  "on break": {
    label: "ON BREAK",
    color: "warning",
    hex: "#f1c40f",
    lightHex: "#fffbe6",
  },

  available: {
    label: "AVAILABLE",
    color: "info",
    hex: "#00a1f1",
    lightHex: "#e6f7ff",
  },
  publishing: {
    label: "PUBLISHING",
    color: "warning",
    hex: "#f1c40f",
    lightHex: "#fffbe6",
  },
  published: {
    label: "0m",
    color: "success",
    hex: "#333333",
    lightHex: "#e3f2fd",
  },
};

export const appTypes = {
  appleTv: "appleTV",
  androidTv: "androidTV",
  fireTv: "fireTV",
  samsungTv: "samsungTV",
} as const;

export type AppType = (typeof appTypes)[keyof typeof appTypes];

// either draft, pending, building, or live type string
export type AppStatus = "draft" | "pending" | "building" | "live";

export const appStatusMap: Record<AppStatus, { label: string; color: string; hex: string; lightHex: string }> = {
  draft: {
    label: "DRAFT",
    color: "info",
    hex: "#808080",
    lightHex: "#f2f2f2",
  },
  pending: {
    label: "PENDING",
    color: "warning",
    hex: "#f1c40f",
    lightHex: "#fffbe6",
  },
  building: {
    label: "BUILDING",
    color: "warning",
    hex: "#f1c40f",
    lightHex: "#fffbe6",
  },
  live: {
    label: "LIVE",
    color: "success",
    hex: "#2eaa30",
    lightHex: "#e3f2fd",
  },
};

const defaultApp: any = {
  ROOT: {
    type: { resolvedName: "Container" },
    props: {},
    isCanvas: true,
    nodes: ["banner", "carousel"],
  },
  banner: {
    type: { resolvedName: "BasicBanner" },
    props: {
      title: "This is Sample App",
      description: "Click around to edit the app",
      showActionButton: false,
      backgroundImageUrl: "https://www.gov.mb.ca/legislature/img/slideshow/slides/p_0001.jpg",
      textColor: "#ffffff",
    },
    isCanvas: false,
    nodes: [],
  },
  carousel: {
    type: { resolvedName: "BasicCarousel" },
    props: {
      title: `Today's Events`,
      showSeeMore: false,
      endDate: new Date(Date.now() + 24 * 60 * 60 * 1000),
    },
    isCanvas: false,
    nodes: [],
  },
};

export const generateDefaultApp = (clientID: string, defaultTheme: any) => {
  return {
    appName: generateRandomAppName(),
    targets: [],
    clientID,
    manifest: {
      status: "draft",
      theme: defaultTheme,
      elements: formatNodes(defaultApp),
    },
  };
};
